import classNames from 'classnames';

/** Global Autocomplete Used classnames */
const autocompleteListItemClassName = (isHighlighted) => {
  return classNames({
    'DropDown-menuItem': true,
    'NoHoverBackground': !isHighlighted
  });
}

/** Global Autocomplete Highlight Item Styles */
const autocompleteListItemStyle = (isHighlighted, styles) => {
  return isHighlighted ? {backgroundColor: '#dcfbff'} : styles.label;
}

module.exports = {
  autocompleteListItemClassName,
  autocompleteListItemStyle
}



// WEBPACK FOOTER //
// ./src/helpers/classNameStyles.jsx